

/**
 * generic function
 * Throttles the execution of any function to limit how frequently it can be called.
 * Ensures that the function is executed at most once every specified delay period.
 *
 * @param fn - The function to throttle.
 * @param delay - The minimum time interval (in milliseconds) between function executions.
 * @returns A throttled version of the provided function.
 */

export function throttle<T extends (...args: any[]) => any>(fn: T, delay: number): T {
    let lastCall = 0;
    return function (...args: Parameters<T>): ReturnType<T> | undefined {
        const now = new Date().getTime();
        if (now - lastCall < delay) {
            return;
        }
        lastCall = now;
        return fn(...args);
    } as T;
}
